/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import { UrlRewritesDispatcher as SourceUrlRewritesDispatcher } from 'SourceStore/UrlRewrites/UrlRewrites.dispatcher';
import { deleteCookie, setCookie } from 'Util/Browser/Cookie';

const CENEO_FEED = 'ceneoAdwIds';
const GOOGLE_FEED = 'googleAdwIds';
const LC_FEED = 'lcAdwIds';
const TIME = 7;

/** @namespace Bookland/Store/UrlRewrites/Dispatcher */
export class UrlRewritesDispatcher extends SourceUrlRewritesDispatcher {
    onSuccess({ urlResolver }, dispatch, { urlParam }) {
        super.onSuccess({ urlResolver }, dispatch, { urlParam });

        this.setCookieIfFeed(CENEO_FEED, urlResolver);
        this.setCookieIfFeed(GOOGLE_FEED, urlResolver);
        this.setCookieIfFeed(LC_FEED, urlResolver);
    }

    setCookieIfFeed(type, urlResolver) {
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop)
        });

        let detectParam = false;

        switch (type) {
        case GOOGLE_FEED: detectParam = params?.gclid; break;
        case CENEO_FEED: detectParam = params?.ceneo_cid; break;
        case LC_FEED: detectParam = params?.bbclid; break;
        default: break;
        }

        if (detectParam) {
            switch (type) {
            case GOOGLE_FEED:
                deleteCookie(CENEO_FEED);
                deleteCookie(LC_FEED);
                break;
            case CENEO_FEED:
                deleteCookie(GOOGLE_FEED);
                deleteCookie(LC_FEED);
                break;
            case LC_FEED:
                deleteCookie(CENEO_FEED);
                deleteCookie(GOOGLE_FEED);
                break;
            default: break;
            }

            setCookie(type, urlResolver?.id, TIME);
            setCookie('savedIdFromFeed', 'true', null);
        }
    }
}

export default new UrlRewritesDispatcher();
